export default __webpack_public_path__ + "static/media/atomicHabits.fc97a782.jpg";